import { rolePermissionTypes } from "../types/rolePermissionTypes";
// import { userPermissionTypes } from "../types/userPermissionTypes";
const initialState = {
    roleData: [],
    rolePermissionData: [],
    userData: [],
    userPermissionData: null,
    permissionLoading: false   
};

export const rolePermissionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case rolePermissionTypes.ROLE_DATA:
      return {
        ...state,
        roleData: payload
      };
    case rolePermissionTypes.ROLE_PERMISSION_DATA:
      return {
        ...state,
        rolePermissionData: payload
      };
      
      case rolePermissionTypes.USER_DATA:
      return {
        ...state,
        userData: payload
      };
      case rolePermissionTypes.USER_PERMISSION_LOADING:
        return {
          ...state,
          permissionLoading: true
        };
      case rolePermissionTypes.USER_PERMISSION_DATA:
      return {
        ...state,
        userPermissionData: payload,
        permissionLoading: false
      };
      case rolePermissionTypes.USER_PERMISSION_LOADED:
      return {
        ...state,
        permissionLoading: false
      };
      
    default:
      return state;
  }
}









